(function () {
  'use strict';

  // ---- Money formatting -------------------------------------------------
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return (cents / 100).toFixed(2);

    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(match[0], value);
  }

  // ---- Product page: variant + gallery ------------------------------------
  function initProduct(section) {
    var productJson = section.querySelector('[data-product-json]');
    if (!productJson) return;
    var product = JSON.parse(productJson.textContent);
    var formatEl = section.querySelector('[data-money-format]');
    var moneyFormat = formatEl ? JSON.parse(formatEl.textContent) : null;

    var select = section.querySelector('[data-variant-select]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var addBtn = section.querySelector('[data-add-button]');
    var mainImg = section.querySelector('.product__main-img');
    var thumbs = section.querySelectorAll('[data-thumb]');

    function showImage(src, mediaId) {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', String(t.dataset.mediaId) === String(mediaId));
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showImage(thumb.dataset.src, thumb.dataset.mediaId);
      });
    });

    if (select) {
      select.addEventListener('change', function () {
        var id = Number(select.value);
        var variant = product.variants.find(function (v) { return v.id === id; });
        if (!variant) return;

        if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
        if (variant.featured_media) {
          var thumb = section.querySelector('[data-thumb][data-media-id="' + variant.featured_media.id + '"]');
          if (thumb) showImage(thumb.dataset.src, variant.featured_media.id);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    }
  }

  // ---- Collection sort ----------------------------------------------------
  function initSort() {
    var sort = document.querySelector('[data-sort-select]');
    if (!sort) return;
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // ---- Mobile drawer: place panel below header ----------------------------
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    var header = document.querySelector('[data-header]');
    if (!drawer || !header) return;
    drawer.addEventListener('toggle', function () {
      var rect = header.getBoundingClientRect();
      document.documentElement.style.setProperty('--drawer-top', rect.bottom + 'px');
      document.body.style.overflow = drawer.open ? 'hidden' : '';
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990 && drawer.open) drawer.open = false;
    });
  }

  // ---- Login: toggle recover password -------------------------------------
  function initRecover() {
    var recover = document.getElementById('RecoverPassword');
    var login = document.getElementById('CustomerLogin');
    if (!recover || !login) return;
    function show(isRecover) { recover.hidden = !isRecover; login.hidden = isRecover; }
    document.querySelectorAll('[data-toggle-recover]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        show(recover.hidden);
      });
    });
    if (window.location.hash === '#recover') show(true);
  }

  // ---- Announcement rotator ----------------------------------------------
  function initRotator(root) {
    var items = root.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    var interval = Number(root.dataset.interval) || 5000;
    setInterval(function () {
      var current = items[i];
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      setTimeout(function () { current.classList.remove('is-leaving'); }, 500);
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
  }

  // ---- Feature slider (auto-rotates on mobile, dots) ----------------------
  function initSlider(root) {
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;
    var i = 0;
    var interval = Number(root.dataset.interval) || 5000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(Number(d.dataset.dot)); restart(); });
    });
    var timer;
    function restart() {
      clearInterval(timer);
      timer = setInterval(function () {
        if (window.innerWidth < 990) go(i + 1);
      }, interval);
    }
    restart();
  }

  // ---- Auto-submit selects (country / currency) ---------------------------
  function initAutosubmit() {
    document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
      el.addEventListener('change', function () { if (el.form) el.form.submit(); });
    });
  }

  function init() {
    document.querySelectorAll('[data-rotator]').forEach(initRotator);
    document.querySelectorAll('[data-slider]').forEach(initSlider);
    initAutosubmit();
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    initSort();
    initDrawer();
    initRecover();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-init when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-product-section]');
    if (s) initProduct(s);
  });
})();
